"use strict";

require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SAVED_POSITION_KEY = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.match.js");
var _react = _interopRequireWildcard(require("react"));
var _reactViewRouter = require("react-view-router");
var _TransitionPresenter = _interopRequireDefault(require("./TransitionPresenter"));
var _TransitionPresenterContext = _interopRequireDefault(require("./TransitionPresenterContext"));
require("./router-view.css");
var _excluded = ["name", "transition", "transitionPrefix", "transitionDuration", "transitionZIndex", "transitionFallback", "routerView", "router", "container", "containerStyle", "getContainerRef"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Retained for consumers of the original transition storage key.
var SAVED_POSITION_KEY = exports.SAVED_POSITION_KEY = '_REACT_VIEW_ROUTER_TRANSITION_POSITIONS_';

/** 默认动效时长（ms），与 router-view.css 保持一致 */
var DEFAULT_TRANSITION_MS = 300;

/**
 * 判断 transitionend 是否为目标动画属性结束事件。
 * @param event transitionend 事件对象
 * @returns 是否为 transform 或 opacity 的过渡结束
 */
function isTransitionEndEvent(event) {
  var prop = event.propertyName;
  return prop === 'transform' || prop === '-webkit-transform' || prop === 'opacity';
}

/**
 * Match the view's local backdrop instead of assuming the document body's color.
 */
function getViewBackgroundColor(node, explicitColor) {
  if (explicitColor) return explicitColor;
  var parent = node && node.parentElement;
  while (parent) {
    var color = window.getComputedStyle(parent).backgroundColor;
    var alpha = color && color.match(/[,/]\s*(0(?:\.\d+)?|1(?:\.0+)?)\s*\)$/);
    if (color && color !== 'transparent' && (!alpha || Number(alpha[1]) === 1)) return color;
    parent = parent.parentElement;
  }
  return '';
}
function isPush(to) {
  return Boolean(to && (to.action === 'PUSH' || to.params.isPush || to.query.isPush));
}
function isPop(to, prevRoute) {
  return Boolean(!to && prevRoute || to && (to.action === 'POP' || to.params.isBack || to.params.isPop || to.query.back));
}
function isReplace(to, prevRoute) {
  return Boolean(to && to.action === 'REPLACE' && !isPush(to) && !isPop(to, prevRoute));
}
var RouterViewTransition = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var name = props.name,
    _props$transition = props.transition,
    transition = _props$transition === void 0 ? 'slide' : _props$transition,
    _props$transitionPref = props.transitionPrefix,
    transitionPrefix = _props$transitionPref === void 0 ? 'react-view-router-' : _props$transitionPref,
    transitionDuration = props.transitionDuration,
    _props$transitionZInd = props.transitionZIndex,
    transitionZIndex = _props$transitionZInd === void 0 ? 1000 : _props$transitionZInd,
    _props$transitionFall = props.transitionFallback,
    transitionFallback = _props$transitionFall === void 0 ? '' : _props$transitionFall,
    routerView = props.routerView,
    defaultRouter = props.router,
    container = props.container,
    containerStyle = props.containerStyle,
    getContainerRef = props.getContainerRef,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var router = (0, _reactViewRouter.useRouter)(defaultRouter);
  var _useState = (0, _react.useState)(() => ({
      container: null
    })),
    _useState2 = (0, _slicedToArray2.default)(_useState, 1),
    $refs = _useState2[0];
  var setContainerRef = (0, _react.useCallback)(node => {
    $refs.container = node;
  }, [$refs]);
  var getTransitionContainer = (0, _react.useCallback)(() => $refs.container, [$refs]);
  if (routerView === RouterViewTransition) routerView = undefined;
  var suppliedContainerStyle = containerStyle;
  var transitionContainerStyle = (0, _reactViewRouter.isPlainObject)(transition) ? transition.containerStyle : null;
  containerStyle = (0, _react.useMemo)(() => Object.assign({
    height: '100%'
  }, suppliedContainerStyle, transitionContainerStyle), [suppliedContainerStyle, transitionContainerStyle]);
  var backgroundColor = containerStyle.backgroundColor;
  var containerTag = 'div';
  if ((0, _reactViewRouter.isPlainObject)(transition)) {
    transitionZIndex = transition.zIndex || transitionZIndex;
    containerTag = transition.containerTag || containerTag;
    transition = transition.name || 'slide';
  }
  var transitionMap = (0, _react.useMemo)(() => {
    var isSlideNode = node => node && node.className.includes(transitionPrefix + 'slide');
    var isOpacityNode = node => node && ['fade', 'zoom'].some(name => node.className.includes(transitionPrefix + name));
    var duration = typeof transitionDuration === 'number' && isFinite(transitionDuration) && transitionDuration >= 0 ? transitionDuration : DEFAULT_TRANSITION_MS;
    var prepareSlideNode = node => {
      if (!isSlideNode(node)) return;
      if (transitionZIndex && transitionZIndex !== 1000) node.style.zIndex = String(transitionZIndex);
      var color = getViewBackgroundColor(node, backgroundColor);
      if (color) node.style.backgroundColor = color;
    };
    var restoreSlideNode = node => {
      if (!isSlideNode(node)) return;
      if (transitionZIndex && transitionZIndex !== 1000) node.style.zIndex = '';
      node.style.backgroundColor = '';
    };
    var transitionProps = {
      timeout: transition === 'none' ? 0 : duration,
      getTimings: classNames => classNames === `${transitionPrefix}fade-through` ? {
        enterDelay: duration * 0.4,
        exitDuration: duration * 0.4
      } : {},
      addEndListener: (node, done) => {
        var to = router.currentRoute;
        if (!isOpacityNode(node) && isReplace(to, router.prevRoute) || isSlideNode(node) && (node.className.includes('slide-right-enter') || node.className.includes('slide-left-exit') || /slide-(?:up|down)-back-enter/.test(node.className) || /slide-(?:up|down)-exit/.test(node.className))) {
          return done();
        }
        /**
         * 仅监听目标属性的 transitionend，避免 iOS 上多余事件导致状态机异常。
         */
        var handleEnd = e => {
          if (e.target !== node || !isTransitionEndEvent(e)) return;
          node.removeEventListener('transitionend', handleEnd);
          done();
        };
        node.addEventListener('transitionend', handleEnd, false);
      },
      onEnter: prepareSlideNode,
      onEntered: restoreSlideNode,
      onExitSnapshot: prepareSlideNode,
      onExited: maybeNode => {
        // if (maybeNode) {
        //   maybeNode.childNodes.forEach(node => {
        //     if (!node[KEEP_ALIVE_REPLACER]
        //       || node.$refs.mountRoot !== maybeNode) return;
        //     node.unmountView();
        //   })
        // }
        restoreSlideNode(maybeNode);
      }
    };
    var forwardNames = {
      slide: 'slide-left',
      carousel: 'carousel-left',
      'fade-slide': 'fade-slide-left',
      zoom: 'zoom-in'
    };
    var directional = function directional(forward, back) {
      var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'together';
      return {
        mode,
        props: {
          classNames: () => {
            var to = router.currentRoute;
            var name = isPush(to) ? forward : isPop(to, router.prevRoute) ? back : '';
            if (!name) {
              var fallback = (0, _reactViewRouter.isFunction)(transitionFallback) ? transitionFallback(to) : transitionFallback;
              name = forwardNames[fallback] || fallback;
            }
            if (name === 'none') return '';
            return name ? `${transitionPrefix}${name}` : name;
          }
        }
      };
    };
    var map = {
      none: {
        mode: 'out-in',
        props: {}
      },
      fade: {
        mode: 'out-in',
        props: {
          classNames: `${transitionPrefix}fade`
        }
      },
      slide: directional('slide-left', 'slide-right', 'in-out'),
      carousel: directional('carousel-left', 'carousel-right'),
      'slide-up': directional('slide-up', 'slide-up-back', 'in-out'),
      'slide-down': directional('slide-down', 'slide-down-back', 'in-out'),
      'fade-slide': directional('fade-slide-left', 'fade-slide-right'),
      zoom: directional('zoom-in', 'zoom-out'),
      'fade-through': {
        mode: 'out-in',
        props: {
          classNames: `${transitionPrefix}fade-through`
        }
      }
    };
    var transitionItem = map[transition];
    if (transitionItem) Object.assign(transitionItem.props, transitionProps);
    return transitionItem || {
      mode: 'none',
      props: {}
    };
  }, [router, transitionFallback, transition, transitionPrefix, transitionDuration, transitionZIndex, backgroundColor]);
  var presenterOptions = (0, _react.useMemo)(() => ({
    transitionMap,
    containerTag,
    containerStyle,
    setContainerRef
  }), [transitionMap, containerTag, containerStyle, setContainerRef]);
  return /*#__PURE__*/_react.default.createElement(_TransitionPresenterContext.default.Provider, {
    value: presenterOptions
  }, /*#__PURE__*/_react.default.createElement(routerView || _reactViewRouter.RouterView, _objectSpread({
    ref,
    name,
    router: defaultRouter,
    container,
    viewPresenter: _TransitionPresenter.default,
    getContainerRef: getContainerRef || getTransitionContainer
  }, restProps)));
});
var _default = exports.default = RouterViewTransition;